import React, { useState, useContext, useEffect } from 'react';
import './Login.css';
import { AuthContext } from '../AuthContext/AuthContext';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import ForgotPasswordModal from './ForgotPasswordModal';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Login = () => {
  const { login }   = useContext(AuthContext);
  const navigate    = useNavigate();
  const [username,          setUsername]          = useState('');
  const [password,          setPassword]          = useState('');
  const [loading,           setLoading]           = useState(false);
  const [forgotModalIsOpen, setForgotModalIsOpen] = useState(false);

  useEffect(() => {
    document.body.classList.add('login-page');
    return () => document.body.classList.remove('login-page');
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE}/api/login`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ username, password }),
      });
      const data = await response.json();

      // ── Usuario inactivo ──────────────────────────────
      if (data.inactive) {
        Swal.fire({
          icon:  'warning',
          title: 'Usuario Inactivo',
          text:  'Tu cuenta está desactivada. Contacta al administrador del sistema.',
        });
        return;
      }

      // ── Credenciales incorrectas ──────────────────────
      if (!data.exists) {
        Swal.fire({
          icon:  'error',
          title: 'Acceso No Autorizado',
          text:  'Nombre de usuario o contraseña incorrectos. Intenta nuevamente.',
        });
        return;
      }

      // ── Acceso concedido ──────────────────────────────
      login(data.data);
      Swal.fire({
        icon:  'success',
        title: 'Acceso Autorizado',
        text:  `Bienvenido, ${data.data.full_name}`,
        timer: 1500,
        showConfirmButton: false,
      }).then(() => navigate('/home'));

    } catch {
      Swal.fire({
        icon:             'error',
        title:            'Error de Conexión',
        text:             'No fue posible conectar con el servidor. Intenta más tarde.',
        confirmButtonText: 'OK',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-image-container" />

      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="input-group">
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoComplete="username"
            placeholder="Nombre de Usuario"
          />
        </div>

        <div className="input-group">
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            placeholder="Contraseña"
          />
        </div>

        <div className="forgot-password">
          <span onClick={() => setForgotModalIsOpen(true)}>
            ¿Olvidaste tu Contraseña?
          </span>
        </div>

        <button type="submit" className="btn" disabled={loading}>
          {loading ? 'Verificando…' : 'Ingresar'}
        </button>
      </form>

      {forgotModalIsOpen && (
        <ForgotPasswordModal
          isOpen={forgotModalIsOpen}
          onRequestClose={() => setForgotModalIsOpen(false)}
        />
      )}
    </div>
  );
};

export default Login;